import { MessageMedium } from 'modules/domains/campaign';
import { GraphQLTypeNameData, GRAPHQL_TYPENAMES, Instant } from 'modules/graphql/types';
import { AggregationType } from './aggregation';
import { AttributionMode } from './attribution';

export enum ConversionEventState {
  Active = 'Active',
  Inactive = 'Inactive',
}

// Partial conversion event types
export type ConversionEventNameData = { name: string };
export type ConversionEventUpdatedAtData = { updatedAt: Instant | null };
export type ConversionEventStateData = { state: ConversionEventState };
export type ConversionEventAllowedMessageMediumsData = { allowedMessageMediums: MessageMedium[] };
export type ConversionEventAttributionModeData = { attributionMode: AttributionMode };
export type ConversionEventAggregationTypeData = { aggregationType: AggregationType };
export type ConversionEventTypeNameData = GraphQLTypeNameData<GRAPHQL_TYPENAMES.CONVERSION_EVENT>;

// Full type (NOTE: please add new conversion event partial types to this union)
export type ConversionEvent = ConversionEventNameData &
  ConversionEventUpdatedAtData &
  ConversionEventStateData &
  ConversionEventAllowedMessageMediumsData &
  ConversionEventAttributionModeData &
  ConversionEventAggregationTypeData &
  ConversionEventTypeNameData;
